import { wbColors } from '@workbuzz/shared-ui';

// Colour priority: (1) wbColors from @workbuzz/shared-ui — check it first, it has more colours
// than this file. (2) Named constants below — only when no wbColors match exists. (3) Never
// write raw hex literals inline.

export const DARK_ORANGE = '#f36d2b';
export const GREY_TEXT = '#444446';
export const WHITE = wbColors.white;
export const GREY_BACKGROUND = '#333333';
export const LIGHT_GREY = '#5c5c5c';
export const CHART_TOOLTIP_BORDER_GREY = '#cccccc';

export const TEXT_COLOR = wbColors.mineShaft;
export const BOULDER = wbColors.boulder;
export const MARINER = wbColors.mariner;
export const GRAY_NURSE = wbColors.grayNurse;
export const MIDNIGHT_EXPRESS = wbColors.midnightExpress;
// Info alert background, replicated from act-ui's `zumthor` theme colour (see `component/Alert`).
// Not in wbColors yet — move to it once the Alert component moves to wb-shared-ui.
export const ZUMTHOR = '#E6EEFF';

// TABLE
export const GREY_CELL = wbColors.barelyWhite;
export const GREY_CELL_TEXT = wbColors.mineShaft;
export const RESTRICTED_COLUMN = wbColors.barelyWhite;
export const RESTRICTED_COLUMN_TEXT = '#8c8c8c';
export const OVERALL_COLUMN = '#a5ac52';

// BUTTONS
export const BUTTON_ORANGE = '#f57e26';
export const BUTTON_BORDER = '#d4d4d4';
export const BUTTON_SHADOW = 'rgba(173, 173, 173, 0.47)';

// PERCENTAGE BAR
export const START_ORANGE = '#f17828';
export const MIDDLE = '#f48d22';
export const END_ORANGE = '#f15a30';

// BAR CHART
export const LINE = '#dfdfdf';

// SCROLL BAR
export const LIGHT_SCROLL_BACKGROUND = '#e1e1e1';
export const LIGHT_SCROLL_TRACK = '#bbbbbb';
export const SCROLL_BAR_BACKGROUND = '#4a4a4a';
export const SCROLL_BAR_TRACK = wbColors.tin;

// ENGAGEMENT BAR
export const ENGAGEMENT_GREY = '#cccccc';
export const ENGAGEMENT_GREEN = '#83b348';
export const VIEW_DETAILS_GREY = '#686868';

// QUESTION TABLE
export const FLAG_BLUE = '#32B0F0';

// REPORT
export const ORANGE_TEXT = '#f57a14';

// COMMENT
export const BORDER_ANSWER = '#e3e4e5';
export const BACKGROUND_COMMENT = '#ecedef';
export const SEARCH_ICON = '#9e9e9f';

// INSIGHTS
export const ERROR_LABEL = '#66686b';

// ICONS
export const GREY_ICON = '#BEBEBE';
export const ADD_YOUR_OWN_ICON_BACKGROUND = '#D9D9D9'; // no wbColors equivalent
export const FROST_FAIRY = '#BFCBEE'; // no wbColors equivalent

// DASHBOARD REDESIGN ----------------------------
// PAGE
export const PAGE_BACKGROUND = wbColors.hototBunny;

// WORKBUZZ_BLUE
export const WORKBUZZ_BLUE = wbColors.eastBay;

// WORKBUZZ_ORANGE
export const WORKBUZZ_ORANGE = wbColors.mangoTango;
export const WORKBUZZ_ORANGE_BAR_BACKGROUND = '#F9E3CC';

// BLACK
export const BLACK = wbColors.mineShaft;
export const DARK_GREY = wbColors.darkGrey;

// PLATINUM
export const PLATINUM = wbColors.grayNurse;
export const IRON = wbColors.iron;
export const SONIC_SILVER = wbColors.boulder;
export const ASH_IN_THE_AIR = wbColors.ashInTheAir;

export const GREEN_GARLANDS = wbColors.greenGarlands;
export const STEEL = wbColors.steel;
export const CARDINAL = wbColors.cardinal;

// Sentiment
export const VIRIDIAN = '#3A8377';
export const SHADOW_GREEN = wbColors.shadowGreen;
export const EDGEWATER = '#C6E0DD'; // intentionally differs from wbColors.edgewater (#CAE2DF)
export const SIDECAR = '#F3DDC2';
export const GOLD_SAND = '#E7BB88';
export const DI_SERRIA = '#DC9B51';
export const PETITE_ORCHID = '#DD9599';
export const CHESTNUT_ROSE = '#CE6266';
export const FLUSH_MAHOGANY = '#C23737';

// HEAT MAP
export const TEAL_80 = '#008577CC';
export const TEAL_60 = '#00857799';
export const TEAL_25 = '#00857740';
export const MANGO_TANGO_25 = '#e0740040';
export const MANGO_TANGO_50 = '#e0740080';
export const MANGO_TANGO_75 = '#e07400bf';
export const CARDINAL_50 = '#d3232f80';
export const CARDINAL_60 = '#d3232f99';
export const CARDINAL_70 = '#d3232fb3';

// SENTIMENT
export const SENTIMENT_BACKGROUND_POSITIVE = wbColors.aquaHaze;
export const SENTIMENT_BACKGROUND_NEUTRAL = wbColors.peachUmbrella;
export const SENTIMENT_BACKGROUND_NEGATIVE = wbColors.cinderella;
export const SENTIMENT_BACKGROUND_DEFAULT = wbColors.alabaster;

// OTHER
export const PROGRESS_BAR_BLUE = '#d2ddf5';
export const REGENT_GRAY = '#7F89A3';
export const OXFORD_BLUE = '#3A4254';
export const WARP_DRIVE = wbColors.aquaHaze;
export const PEACH_UMBRELLA = wbColors.peachUmbrella;
export const CINDERELLA = wbColors.cinderella;
export const GREEN_HAZE = '#00A84F';
export const CORNFLOWER_BLUE = '#e6eeff'; // intentionally differs from wbColors.cornflowerBlue (#5383EC)
export const HARD_COAL = wbColors.doveGray;
export const BACK_LIGHT = wbColors.backlight;
export const GRAY_NURSE40 = wbColors.grayNurse40;
export const GRAY_NURSE80 = wbColors.grayNurse80;

// FEEDBACK_BAR
export const WARP_DRIVE_DARKER = '#9acac1';
export const GREEN_HAZE_DARKER = '#007e3b';
export const CINDERELLA_DARKER = '#f47777';
export const CARDINAL_DARKER = '#9e1a23';
